/**
 * @voltxampere/ui — LDR (CdS photoresistor) variant (Sprint 43-6)
 *
 * Cadmium Sulfide light-dependent resistor. Resistance varies with
 * illuminance — typical range 1 kΩ (bright sunlight, ~10 klux) to 1 MΩ
 * (dark). The default 10 kΩ corresponds to moderate ambient light
 * (~100 lux); user adjusts via the resistor's slider.
 *
 * Reference: GL5528-class CdS photoresistor (commodity part).
 * Engine zero-diff invariant honored — canonical `resistor` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { resistor } from "../resistor.js";
export const sensorLdr = {
    id: "ldr",
    nameTr: "LDR (CdS Foto Direnç, GL5528)",
    nameEn: "LDR (CdS Photoresistor, GL5528)",
    shortcut: "R",
    category: "passive",
    viewBox: resistor.viewBox,
    terminals: resistor.terminals,
    defaultLabel: "R",
    defaultValue: "10kΩ",
    schemaType: "resistor",
    defaultParams: { resistance: 10e3 },
    renderSVG: () => resistor.renderSVG(),
};
//# sourceMappingURL=sensor-ldr.js.map